/* eslint-disable max-len */
import React, {PropsWithChildren} from 'react';
import styled from 'styled-components';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import {HStack, StackProps, VStack} from '../../../layout/layout.styled';
import {ContentSection} from '../modal-sections.styled';
import {InfoIcon} from './info-icon';

type DisplaySectionProps = PropsWithChildren<{
    variant?: 'error' | 'info' | 'warning'
} & StackProps>;

export const DisplaySection = ({variant = 'info', children, ...restProps}: DisplaySectionProps) => {
    return (
        <SectionBackground variant={variant} {...restProps}>
            <InnerBackground spacing={'10px'} variant={variant}>
                {variant === 'info' ?
                    <InfoIcon/> :
                    <ErrorOutlineOutlinedIcon color={'error'}/>
                }

                <VStack>
                    {children}
                </VStack>
            </InnerBackground>
        </SectionBackground>
    );
};

const SectionBackground = styled(ContentSection)`
  padding: ${(props: DisplaySectionProps) => props.variant === 'warning' ? '15px 15px 0' : '15px 50px 0'};
  background-color: ${(props: DisplaySectionProps) => props.variant === 'warning' ? 'transparent' : '#f8f8f9'};
  margin-bottom: ${(props: DisplaySectionProps) => props.variant === 'warning' ? '5px' : '0'};
  width: ${(props: DisplaySectionProps) => props.variant === 'warning' ? '40%' : 'auto'};
`;

const InnerBackground = styled(HStack)`
  padding-bottom: 0;

  svg {
    width: ${(props: DisplaySectionProps) => props.variant === 'warning' ? '24px' : 'initial'};
    height: ${(props: DisplaySectionProps) => props.variant === 'warning' ? '24px' : 'initial'};
  }

  .MuiSvgIcon-colorError {
    color: #cc471d;
  }
`;
